import { TeamMember } from "@/types/team";

type TeamWithMembers = { members: Array<{ id: string }> };

export const getTeamMemberName = (member: TeamMember): string =>
  [member.firstName, member.lastName].filter(Boolean).join(" ") ||
  member.email ||
  "Unknown";

export const getUserTeams = <TTeam extends TeamWithMembers>(
  teams: TTeam[],
  userId: string | null | undefined,
): TTeam[] =>
  userId
    ? teams.filter((team) =>
        team.members.some((member) => member.id === userId),
      )
    : [];
